/**
 * @generated SignedSource<<a492431266285d2144ec904c482bc25a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductSpecificationsDrawer_Product$data = {
  readonly brand: string;
  readonly specificationGroups: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly name: string;
        readonly specifications: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly name: string;
              readonly values: ReadonlyArray<string>;
            };
          }>;
        };
      };
    }>;
  };
  readonly " $fragmentType": "ProductSpecificationsDrawer_Product";
};
export type ProductSpecificationsDrawer_Product$key = {
  readonly " $data"?: ProductSpecificationsDrawer_Product$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductSpecificationsDrawer_Product">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductSpecificationsDrawer_Product",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "brand",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductSpecificationGroupConnection",
      "kind": "LinkedField",
      "name": "specificationGroups",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProductSpecificationGroupEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ProductSpecificationGroup",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ProductSpecificationConnection",
                  "kind": "LinkedField",
                  "name": "specifications",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ProductSpecificationEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "ProductSpecification",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            (v0/*: any*/),
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "values",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Product",
  "abstractKey": null
};
})();

(node as any).hash = "36c8e7a2d120858a8fea446fc0e3f26a";

export default node;
